module.exports = __webpack_public_path__ + "img/error_desk_planet.b36755d5.png";